/**
 * Компонент для "оживления" кастомных инпутов для файлов.
 * <input type="file" name="resume" id="file_field" data-empty-capt="Загрузить резюме" data-multiple-capt="{count} файлов выбрано">
 <label for="file_field">Загрузить резюме</label>
 */

const LABEL_SELECTOR = '.input-container__label';

export default class FileInput{
    constructor(elem){
        this.elem = elem;
        this.label = elem.parentNode.querySelector(LABEL_SELECTOR);
        this.captions = {
            multiple: this.elem.getAttribute('data-caption') || '',
            empty: this.elem.getAttribute('data-empty') || ''
        };

        if(this.label == undefined){
            console.warn('Label is empty! Please create the label!');
            return;
        }

        this.elem.addEventListener('change', (e) => {
            let fname = '';

            if(e.target.files && e.target.files.length > 1){
                fname = this.captions.multiple.replace('{count}', e.target.files.length);
            }else{
                fname = e.target.value.split('\\').pop();
            }

            if(fname && fname.length > 0){
                this.label.innerText = fname;
            }else{
                this.label.innerText = this.captions.empty;
            }
        });
    }
}